module.exports = __webpack_public_path__ + "img/cvlogo3.43dad968.jpg";